import { create } from 'zustand';
import { User } from '../types';

interface AuthStore {
  user: User | null;
  token: string | null;
  isHydrated: boolean;
  isLoading: boolean;
  error: string | null;
  sessionExpired: boolean;
  setUser: (user: User | null) => void;
  setToken: (token: string | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setSessionExpired: (expired: boolean) => void;
  logout: (options?: { sessionExpired?: boolean }) => void;
  hydrate: () => void;
}

function safeJsonParse<T>(raw: string | null): T | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export const useAuthStore = create<AuthStore>((set, get) => {
  const token = localStorage.getItem('token');
  const user = safeJsonParse<User>(localStorage.getItem('user'));

  return {
    user: user,
    token: token,
    isHydrated: true,
    isLoading: false,
    error: null,
    sessionExpired: false,
    setUser: (user) => {
      set({ user });
      if (user) {
        localStorage.setItem('user', JSON.stringify(user));
      }
    },
    setToken: (token) => {
      set({ token, sessionExpired: false });
      if (token) {
        localStorage.setItem('token', token);
      }
    },
    setLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error }),
    setSessionExpired: (sessionExpired) => set({ sessionExpired }),
    logout: (options) => {
      set({
        user: null,
        token: null,
        sessionExpired: options?.sessionExpired ?? false,
      });
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    },
    hydrate: () => {
      const current = get();
      if (current.isHydrated) return;
      const t = localStorage.getItem('token');
      const u = safeJsonParse<User>(localStorage.getItem('user'));
      if (t && u) {
        set({ token: t, user: u });
      }
      set({ isHydrated: true });
    },
  };
});
